import PropTypes from 'prop-types'

export default PropTypes.shape({
  autoFocus: PropTypes.bool,
  close: PropTypes.func,
  focusBackRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  handleClick: PropTypes.func,
  handleTransitioned: PropTypes.func,
  isOpen: PropTypes.bool,
  open: PropTypes.func,
  targetRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  transitioning: PropTypes.bool,
})
